import { Injectable } from '@angular/core';
import { select, Store, Action } from '@ngrx/store';

import * as fromSchedule from './schedules.reducer';
import * as SchedulesSelectors from './schedules.selectors';
import * as SchedulesActions from './schedules.actions';
import { CreateScheduleDto } from '@care-portals/api-interfaces';

@Injectable({
  providedIn: 'root'
})
export class SchedulesFacade {
  state$ = this.store.pipe(select(SchedulesSelectors.selectState));
  loading$ = this.store.pipe(select(SchedulesSelectors.selectLoading));
  schedules$ = this.store.pipe(select(SchedulesSelectors.selectSchedules));
  activeSchedule$ = this.store.pipe(
    select(SchedulesSelectors.selectActiveSchedule)
  );
  drawer$ = this.store.pipe(select(SchedulesSelectors.selectDrawer));

  constructor(private store: Store<fromSchedule.SchedulesPartialState>) {}

  private dispatch(action: Action) {
    this.store.dispatch(action);
  }

  getSchedule() {
    this.dispatch(SchedulesActions.getSchedule());
  }
  createSchedule(schedule: CreateScheduleDto) {
    this.dispatch(SchedulesActions.createSchedule({ request: schedule }));
  }
  updateSchedule(id: string, changes: any) {
    this.dispatch(SchedulesActions.updateSchedule({ changes }));
  }
  setActiveSchedule(id: string) {
    this.dispatch(SchedulesActions.setActiveSchedule({ id }));
  }
  cleanActiveSchedule() {
    this.dispatch(SchedulesActions.cleanActiveSchedule());
  }
  syncSchedule(id: string) {
    this.dispatch(SchedulesActions.syncSchedule({ id }));
  }
}
